import { writable, get } from "svelte/store";
import { vratStav, ulozStav } from "../api/state";
import { vratModuly } from "../api/user";
import { hooksStore } from "./hooks.store.js";

import isObject from "lodash/isObject";
import set from "set-value";

export const currentUserId = writable(false);
export const apiStoreSaveTimer = writable(false);

// ziskam data z local storage
// ak ziadne nemam, ulozim tam defaultne objekt
export const vratStavZLocalStorage = (user_id) => {
  user_id = user_id || get(currentUserId);
  if (user_id === false) {
    return false;
  }

  const storedUser = localStorage.getItem(`sm-user-${user_id}`);

  if (storedUser) {
    return JSON.parse(storedUser);
  }

  return false;
};

// ukladam stav do local storage a do API
const ulozStavDoLocalStorage = (data) => {
  if (data) {
    try {
      data.updated_at = new Date().toISOString();
      localStorage.setItem(`sm-user-${data.user_id}`, JSON.stringify(data));
      return true;
    } catch (error) {
      console.log(error);
    }
  }

  return false;
};

export const ulozStavDoApi = async (stav) => {
  if (stav) {
    return ulozStav({ options: stav.options });
  }
};
// ukladanie stavu do localStorage aj do API
export const ulozStavDoPamate = async (stav) => {
  // ulozim stav do localStorage a do api
  ulozStavDoLocalStorage(stav);
  // ulozim stav do API
  return ulozStav({ options: stav.options });
};

// ziskanie stavu uzivatela
export const ziskajStavUzivatela = async (prihlasenyUzivatel) => {
  let stav, userData, idAktualnehoUzivatela;
  // ak je hodnota objekt, tak predpokladam ze je to z priihlasenia
  // a tak mozem aktualizovat data uzivatela do stavu
  if (isObject(prihlasenyUzivatel)) {
    idAktualnehoUzivatela = prihlasenyUzivatel.id;
    userData = {
      id: prihlasenyUzivatel.id,
      name: prihlasenyUzivatel.name,
      email: prihlasenyUzivatel.email,
      phone: prihlasenyUzivatel.phone,
      lang: prihlasenyUzivatel.lang,
      login: prihlasenyUzivatel.login,
    };
  } else {
    idAktualnehoUzivatela = prihlasenyUzivatel;
  }
  // ziskam stav z api
  let stavApi = await vratStav();
  // ak nemam ani ID aktualneho uzivatela (prihlaseny po refreshi)
  // a nemam ani stav z API, tak neviem kto je prihlaseny
  // a tak nemozem skontrolovat, ci ma uzlozeny stav v localStorage
  // tak ho natvrdo odhlasim, nech sa znova prihlasi a ziskam ID uzivatela
  // toto by sa uz ale nemalo stat, lebo vzdy pri volani tejto funkcie ukladam stav
  // do localstorage aj do api
  if (idAktualnehoUzivatela === false && stavApi === false) {
    hooksStore.doAction("odhlasitUzivatela");
    return false;
    // ak nemam ID uzivatela ale mam stav z api
  } else if (idAktualnehoUzivatela === false && stavApi.user_id) {
    // ID aktualneho uzivatela si vezmem z API stavu
    idAktualnehoUzivatela = stavApi.user_id;
    currentUserId.set(stavApi.user_id);
  }
  // kedze uz mam ID aktualneho uzivatela, viem si ziskat stav z localStorage
  let stavLocalStorage = idAktualnehoUzivatela
    ? vratStavZLocalStorage(idAktualnehoUzivatela)
    : false;

  // ak nemam stav z API a ani z localStorage, tak vytvorim novy stav
  if (stavApi === false && stavLocalStorage === false) {
    stav = {
      user_id: idAktualnehoUzivatela,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      options: {},
    };

    set(stav, "options.user", userData);

    // ak mam stav aj z API aj z localStorage, tak porovnam ten novsi a ten pouzijem
  } else if (stavApi !== false && stavLocalStorage !== false) {
    const stavApiDate = new Date(stavApi.updated_at);
    const stavLocalStorageDate = new Date(stavLocalStorage.updated_at);
    stav = stavApiDate - stavLocalStorageDate < 0 ? stavLocalStorage : stavApi;

    // inak nastavim ten stav, ktory mam
  } else {
    stav = stavApi || stavLocalStorage;
  }

  // po prihlaseni vzdy updatnem informacie o uzivatelovi z api
  if (userData) {
    set(stav, "options.user", userData);
  }

  return stav;
};

// svelte custom store pre uzivatelske data
function createUser() {
  const { subscribe, set, update } = writable(0);

  return {
    subscribe,
    initStoredUser: async (prihlasenyUzivatel) => {
      // ziskam stav uzivatela bud z api, z localStorage alebo vytvorim novy stav
      let stav = await ziskajStavUzivatela(prihlasenyUzivatel);
      if (stav) {
        // upravim mu datum aktualizacie na aktualny
        stav.updated_at = new Date().toISOString();
        // z api si ziskam zoznam povolenych modulov
        let moduly = await vratModuly();
        stav.modules = moduly ? moduly : [];
        ulozStavDoPamate(stav);
        // nastavim stav do userStore
        set(stav);
        return true;
      }
      return false;
    },
    updateUser: (userData) => {
      if (ulozStavDoLocalStorage(userData)) {
        update((u) => (u = userData));
      }
    },
    getUser: () => vratStavZLocalStorage(),
  };
}

export const userStore = createUser();
